import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const VerbandContext = createContext(null);

export function VerbandProvider({ children }) {
  const [verband, setVerband] = useState(null);       // Subdomain-Verband (read-only)
  const [activeVerband, setActiveVerband] = useState(null); // Super-Admin Switch
  const [loading, setLoading] = useState(true);

  // Beim Start: aktuellen Verband aus Subdomain laden
  const loadCurrentVerband = useCallback(async () => {
    try {
      const res = await fetch('/api/verbaende/current');
      if (res.ok) {
        const data = await res.json();
        if (data.success) {
          setVerband(data.data);
          // Nur setzen wenn noch kein activeVerband gewählt (bei erneutem Laden)
          setActiveVerband(prev => prev ?? data.data);
        }
      }
    } catch (err) {
      console.error('Fehler beim Laden des Verbands:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCurrentVerband();
  }, [loadCurrentVerband]);

  return (
    <VerbandContext.Provider value={{ verband, activeVerband, setActiveVerband, loading }}>
      {children}
    </VerbandContext.Provider>
  );
}

export function useVerband() {
  return useContext(VerbandContext);
}
